import { memo } from 'react';
import PropTypes from 'prop-types';
import { createInvoicePaymentSession, payInvoiceWithSavedCard } from 'api';
import InvoicePayButtonBase from './base';

const InvoicePayButton = ({
  invoiceId,
  portalId,
  totalAmount,
  tipBaseAmount,
  invoiceSettingsOverride,
  creditToBeApplied,
  ...restProps
}) => {
  return (
    <InvoicePayButtonBase
      invoiceId={invoiceId}
      portalId={portalId}
      totalAmount={totalAmount}
      tipBaseAmount={tipBaseAmount}
      invoiceSettingsOverride={invoiceSettingsOverride}
      creditToBeApplied={creditToBeApplied}
      createPaymentSessionAction={createInvoicePaymentSession}
      payWithSavedCardAction={payInvoiceWithSavedCard}
      redirectUrl={`/${portalId}/invoices/${invoiceId}?stripe_result=success`}
      invalidateQueriesOnSkippedPayment={[
        'invoicesListingQuery',
        `invoice-${invoiceId}`,
      ]}
      {...restProps}
    />
  );
};

InvoicePayButton.propTypes = {
  invoiceId: PropTypes.string.isRequired,
  portalId: PropTypes.string.isRequired,
  totalAmount: PropTypes.number.isRequired,
  tipBaseAmount: PropTypes.number,
  invoiceSettingsOverride: PropTypes.shape({
    ccSurchargeOverride: PropTypes.shape({
      enabled: PropTypes.bool.isRequired,
    }),
  }),
  creditToBeApplied: PropTypes.number,
};

InvoicePayButton.defaultProps = {
  tipBaseAmount: null,
  invoiceSettingsOverride: null,
  creditToBeApplied: 0,
};

export default memo(InvoicePayButton);
